const customDropdownFilter = () => {
  $(document).on('click', '.filter__item__btn', (event) => {
    const $this = $(event.currentTarget);
    const parentDiv = $this.closest('div');
    const filterItems = parentDiv.find('.filter__item');

    parentDiv.toggleClass('is-open');
    $('.filter').not(parentDiv).removeClass('is-open');

    filterItems.removeClass('active');
    filterItems.addClass('not-active');

    $this.closest(filterItems).addClass('active');
    $this.closest(filterItems).removeClass('not-active');

    filterItems.removeClass('filter__item__last');
    filterItems.not('.active').last().addClass('filter__item__last');
  });
};

export default customDropdownFilter;
